import { Component } from '@angular/core';
import {NavController, NavParams, ViewController} from "ionic-angular";
import {Api} from "../../providers/api";
import {GVLogger} from "../../services/gv-logger";
import {LoginPage} from "../login/login";
import {MsgManager} from "../../providers/msg-manager";
@Component({
  selector: 'page-reference-list',
  templateUrl: 'reference-list.html',
})
export class ReferenceListPage {
  items = [];
  private searchStatus: boolean = false;
  private productRefSearch: any;
  private productId: any;

  constructor(public navCtrl: NavController, private msgManager:MsgManager, public navParams: NavParams, private viewCtrl:ViewController, public api:Api, private gVLogger: GVLogger) {
    this.items = this.navParams.get("items");
    console.log("itemmsss in ReferenceListPage" + JSON.stringify(this.items));
    this.productRefSearch = this.navParams.get("productRefSearch");
    this.productId = this.navParams.get("productId");
  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad ReferenceListPage');
  }

  supplierSelected(selected: string) :void {
    this.gVLogger.log("supplierSelected : " + selected);
    this.viewCtrl.dismiss(selected);
    // this.reference = selected;
    // this.items = [];
    // this.resultsAvailable = false;
    // this.ignoreNextChange = true;
    // this.gVLogger.log("supplierSelected..... ");
    // this.gVLogger.log("supplierSelected : " + selected);
    //
    // this.gVLogger.log("reference : " + this.reference);
    // this.gVLogger.log("items in cart : " + this.cart.items.length);
    // this.items = [];
    // if(this.reference !== null && this.cart.items.length >= 1){
    //   this.referenceStatus = false;
    // }
  }

  onInputChange(event: any) {
    this.searchStatus = false;
    let substring = event.target.value;

    if(this.productRefSearch === 1){
    //   this.api.get("products/getproductReferencesByProductId/" + substring+"?productId="+this.productId).map(res => res.json()).subscribe(data => {
    //     if (data.status === "200") {
    //       this.items = [];
    //       for (let item of data.data) {
    //         this.items.push(item.referenceNo);
    //         this.gVLogger.log("daaaattaaaaa : " + this.items);
    //       }
    //     } else {
      this.gVLogger.log("product ref search : " + this.searchStatus);
          this.items = [];
          this.searchStatus = true;
    //     }
      this.gVLogger.log("product ref search : " + this.searchStatus);
    //   })
    }
    else {
      if (substring.trim() == "") {
        substring = -1;
      }
      this.api.get("products/getReferencNo/" + substring)
      // this.api.get("products/getProductByBarcode/"+event.target.value)
        .map(res => res.json())
        .subscribe(data => {
          if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.navCtrl.setRoot(LoginPage);
          }
            if (data.status === "200") {
              this.items = [];
              for (let item of data.data) {
                this.items.push(item.referenceNo);
                this.gVLogger.log("daaaattaaaaa : " + this.items);
              }
              this.searchStatus = false;
            } else {
              this.items = [];
              this.searchStatus = true;
              this.gVLogger.log("else case when no data found : " + this.searchStatus);
            }
        });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/reference-list/reference-list.ts